import { memo as Memo, useMemo } from 'react';

//* HOC's
import { withDataContext, withLanguageContext } from 'context';

//* Components
import CustomLink from 'components/common/CustomLink';
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import MenuItem from './MenuItem';
import LanguageSwitcher from 'components/common/LanguageSwitcher';

//* Helpers
import config from 'helpers/_config';

//* Style
import DesktopMenuStyle from './style';

const DesktopMenu = ({ menuData, hasBookmark, translate, selectedLang }) => {
	//! Menu Items
	const menuItemsHtml = useMemo(() => {
		return (
			<ul className='menu-cont'>
				{menuData &&
					Object.values(menuData).map((menuItem, k) => {
						const { key: menuKey, ...menuProps } = menuItem || {};

						return (
							<MenuItem
								selectedLang={selectedLang}
								key={menuKey || k}
								{...menuProps}
							/>
						);
					})}
			</ul>
		);
	}, [menuData]);

	//! Icons HTML
	const iconsHtml = useMemo(() => {
		const iconNames = [
			{ name: 'map', url: config.routes.map.path },
			{ name: 'search', url: config.routes.search.path },

			{ name: 'bookmarks', url: config.routes.bookmarks.path },
		];

		return (
			<div className='header-icons-cont'>
				{iconNames.map((i, k) => (
					<span
						className='icon-cont'
						key={k}
					>
						<CustomLink url={i.url}>
							<Icon
								className={`p pS ${hasBookmark ? 'active' : ''}`}
								name={i.name}
							/>
						</CustomLink>
					</span>
				))}
			</div>
		);
	}, [config, hasBookmark]);

	return (
		<DesktopMenuStyle>
			{menuItemsHtml}

			<CustomLink
				className='events-button font-ping-medium p pS '
				url={config.routes.experience.path}
			>
				{translate('experiences')}
			</CustomLink>

			<CustomLink
				className='events-button font-ping-medium p pS '
				url={config.routes.articles.path}
			>
				{translate('blog')}
			</CustomLink>

			<Button
				url={config.routes.events.path}
				className='events-button'
				text='events'
				type='oval'
			/>

			{iconsHtml}

			<LanguageSwitcher />
		</DesktopMenuStyle>
	);
};

export default withDataContext(withLanguageContext(DesktopMenu, ['translate', 'selectedLang']), ['hasBookmark']);
